// extracted by mini-css-extract-plugin
module.exports = {"container":"menuSelect_container__qmziW","select":"menuSelect_select__1jdl7","label":"menuSelect_label__3Lf2X","errorMessage":"menuSelect_errorMessage__ODJ1D"};